import type { AnchorHTMLAttributes, FC, MouseEvent } from 'react';

import { NOTION_FORMS } from '@/shared/constants/externalLinks';
import type { NotionFormKind } from '@/shared/constants/externalLinks';

import { openNotionFormModal } from './store';

interface NotionFormLinkProps extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
    kind: NotionFormKind;
    modalTitle?: string;
}

const NotionFormLink: FC<NotionFormLinkProps> = ({ kind, modalTitle, onClick, ...props }) => {
    const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
        onClick?.(event);

        if (event.defaultPrevented) {
            return;
        }

        event.preventDefault();
        openNotionFormModal(kind, modalTitle);
    };

    return <a {...props} href={NOTION_FORMS[kind].href} onClick={handleClick} />;
};

export default NotionFormLink;
